import React from "react";
import { genURL, gengetURLTEST } from '../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from "axios";
require('./../_css/PopUpOther.css');
export default class PopUpOther extends React.Component {
    constructor(props) {
        super(props);
        this.Search = React.createRef();
        this.CustomerName = React.createRef();
        this.state = {
            type: this.props.type,
            rows: [],
            valueRetuen: "",
            Htext: "",
            SHtype: 3,
            selected: "1",
        }
    }
    componentDidMount() {
        var url = "";
        switch (this.props.type) {
            case "T_Expcode":
                url = "CSINCOME/GETALL?Top=300";
                console.log(genURL(url));
                axios.get(genURL(url), { timeout: 5000 }).then((res) => {
                    var dataArray = [];
                    for (let i = 0; i < res.data.length; i++) {
                        dataArray[i] = {
                            number: i + 1,
                            code: res.data[i].CODE,
                            text: res.data[i].MYNAMETH,
                            WTAXRATE: res.data[i].WTAXRATE == null ? "" : res.data[i].WTAXRATE,
                            CALCTAX: res.data[i].CALCTAX,
                            CALCWTAX: res.data[i].CALCWTAX,
                        }
                    }
                    this.setState({ rows: dataArray });
                }).catch(error => {
                    console.log(error);
                });
                this.setState({ Htext: "ค้นหารายการ" });
                break;
            default: break;
        }
    }
    onKeyUp = (e) => {
        if (e.key === 'Enter') {
            var txt = e.target.value;
            this.getItemar(txt);
        }
    }
    onClickSearch = () => {
        var txt = this.CustomerName.current.value;
        this.getItemar(txt);
    }
    getItemar = (data1) => {
        let urlmain;
        if (this.state.selected === "0") {
            urlmain = "CSINCOME/GETCODES?Top=100&Codes=";
        } else {
            urlmain = "CSINCOME/GETNAME?Top=100&Name=";
        }
        this.setState({ openBackdrop: true })
        var url = urlmain + data1 + "&user=" + localStorage.getItem("Username")
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 5000 }).then(async (res) => {
            var dataArray = [];
            for (let i = 0; i < res.data.length; i++) {
                dataArray[i] = await {
                    number: i + 1,
                    code: res.data[i].CODE,
                    text: res.data[i].MYNAMETH,
                    WTAXRATE: res.data[i].WTAXRATE == null ? "" : res.data[i].WTAXRATE,
                    CALCTAX: res.data[i].CALCTAX,
                    CALCWTAX: res.data[i].CALCWTAX,
                }
            }
            await this.setState({ rows: dataArray });
        }).catch(error => {
            console.log(error);
        });
    }
    onSelectRow = (data) => {
        this.setState({ valueRetuen: data.code });
        var reData;
        switch (this.props.type) {
            default:
                reData = data.code + "|" + data.text + "|" + data.WTAXRATE + "|" + data.CALCWTAX + "|" + data.CALCTAX
                break;
        }
        setTimeout(() => {
            this.props.Get_PopUpOther2(reData);
        }, 0);
    }
    render() {
        return (
            <div className='popup'  >
                <div className='popup_inner '>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search" > {this.state.Htext} </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>

                    <div className="panel-body divTable" align="left" >
                        <div className="DivTable">
                            <div className="form-inline">
                                <div className="form-group mb-2">
                                    <input type='radio' id='Choice-1' name='myRadio' value='0'
                                        checked={this.state.selected === '0'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                                    <input type='radio' id='Choice-2' name='myRadio' value='1'
                                        checked={this.state.selected === '1'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;&nbsp;</span>
                                </div>
                            </div>
                        </div>
                        <div className="input-group width-grop">
                            <input type="text" className="form-control" placeholder="กรอกคำค้นหา" onKeyUp={this.onKeyUp} ref={this.CustomerName} />
                            <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={this.onClickSearch}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.componentDidMount() }}></i></span>
                        </div>

                        <BootstrapTable
                            data={this.state.rows}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูลที่ค้นหา",
                            }}
                            height="750"
                            hover condensed >
                            <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataField='number' dataAlign="center" width="5" isKey> </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='code' width="30"  > รหัส </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='text' width="100"  > ชื่อ/คำอธิบาย </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='WTAXRATE' width="50" dataAlign="center"  > % หักณที่จ่าย</TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='CALCWTAX' width="35" dataAlign="center" > W </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='CALCTAX' width="35" dataAlign="center" > T </TableHeaderColumn>
                        </BootstrapTable>

                    </div>
                </div>
            </div>
        );
    }
}